import React, { useRef } from "react";
import "./style.css";
import McqCard from "../McqCard";

const McqQueSection = ({ apiData }) => {
  return (
    <div className="mcqQueSection">
      {apiData.map((data, index) => (
        <McqCard
          key={data._id}
          data={data}
          sNo={index + 1}
          questionIndex={index}
        />
      ))}
    </div>
  );
};

export default McqQueSection;
